import { useLocale } from "@/composables/use-locale";
import { useNavigation } from "@/composables/use-navigation";
import { useModalHubStore } from "@/components/modal-hub";
import { useBasketStore } from "@/stores/basket";

type PendingLineItem = Parameters<
  ReturnType<typeof useBasketStore>["addItem"]
>[0];

export const useDeliveryLocationPrompt = () => {
  const basket = useBasketStore();
  const modalHub = useModalHubStore();
  const { t } = useLocale();
  const { push } = useNavigation();

  const ensureDeliveryLocation = (pendingItem?: PendingLineItem) => {
    if (!basket.needsDeliveryLocation) return true;

    modalHub.showWarning({
      title: t("pages.outlet.warn_missing_address_title"),
      message: t("pages.outlet.warn_missing_address_message"),
      dismissLabel: t("pages.outlet.warn_missing_address_dismiss"),
      confirmLabel: t("pages.outlet.warn_missing_address_confirm"),
      onWarningConfirm: () => {
        if (pendingItem) {
          basket.addPendingAction({
            type: "addLineItem",
            outletId: basket.outletId,
            item: pendingItem,
          });
        }

        modalHub.hideWarning();
        push("order", { orderingMode: "delivery" });
      },
    });

    return false;
  };

  return { ensureDeliveryLocation };
};
